import { Recordatorio } from '../../domain/entities/Recordatorio';
import { RecordatorioRepository } from '../../domain/repositories/RecordatorioRepository';

const MOCK_RECORDATORIOS: Recordatorio[] = [
  {
    nroRecordatorio: 1025,
    codigoFideicomiso: 'FI001',
    nitCliente: '900123456',
    estado: 'ACTIVO',
    fechaRegistro: '2026-01-15',
    nombreFideicomiso: 'Fideicomiso Demo',
    nombreCliente: 'Cliente Demo S.A.S.',
    saldoTotalCapital: 800000,
    saldoTotalMora: 200000,
    saldoTotalAdeudado: 800000,
    valorTotalMora: 50000
  }
];

export class MockRecordatorioRepository implements RecordatorioRepository {
  async findByNumero(nroRecordatorio: number): Promise<Recordatorio | null> {
    return MOCK_RECORDATORIOS.find(r => r.nroRecordatorio === nroRecordatorio) || null;
  }

  async registerPayment(data: any): Promise<{ id: number }> {
    console.log('[Mock] Registrando pago de recordatorio:', data);
    return { id: Math.floor(Math.random() * 10000) };
  }
}
